<template>
  <div>
    <el-carousel :height="height" :interval="interval">
      <el-carousel-item v-for="item in list" :key="item.id" style="text-align: center;">
        <img :src="item.imgUrl" @click="openParticulars(item.id)" style="max-width: 100%;max-height: 100%;"/>
      </el-carousel-item>
    </el-carousel>
    <homeNewsParticulars ref="homeNewsParticulars" :id="selectId" />
  </div>
</template>
<script>
import req from "@/request.js";
import homeNewsParticulars from "@/components/home/homeNewsParticulars.vue";

export default {
  props: {
    classifyId: {
      default: "all"
    },
    height: { String },
    interval:{
      default: 3000
    },
  },
  components: { homeNewsParticulars },
  data() {
    return {
      list: [],
      selectId: null
    };
  },
  created() {
    this.init();
  },
  methods: {
    openParticulars(id) {
      this.selectId = id;
      this.$refs.homeNewsParticulars.openDialog();
    },
    init() {
      req
        .get(
          window.context.portal +
            "/portalNewsNotice/v1/getNews?classifyId=" +
            this.classifyId
        )
        .then(response => {
          for (let x = 0; x < response.data.length; x++) {
            if (response.data[x].rotatingDisplayPictures) {
              response.data[x].imgUrl =
                window.context.portal +
                "/system/file/v1/downloadFile?fileId=" +
                response.data[x].rotatingDisplayPictures;
            }
          }
          this.list = response.data;
        });
    }
  }
};
</script>
